import React, { useState } from 'react';
import '../styles/ContactForm.css';
import Footer from "./Footer";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setSubmitMessage({
        type: 'success',
        text: 'Your message has been sent! We will get back to you soon.'
      });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      setSubmitMessage({
        type: 'error',
        text: 'Sorry! Something went wrong. Please try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
   <div className="contact-page">
  <div className="contact-container">
    <section className="contact-intro">
      <h1>📬 Contact Us</h1>
      <p>Do you have questions, feedback, or need help?</p>
      <p>We at Kiwispinworld want to hear from you!</p>
      <p>Whether it’s about responsible gaming, privacy, technical issues, or collaboration – we are here to help. 🙌</p>
    </section>

    <div className="contact-grid">
      <section className="contact-info">
        <div className="info-card">
          <h2>🧾 General Contact</h2>
          <ul>
            <li><span>📧</span> <strong>Email:</strong> Kiwispinworld@gmail.com</li>
            <li><span>📞</span> <strong>Phone:</strong> +47 22 83 70 10</li>
            <li>
              <span>📍</span> <strong>Address:</strong><br />
              Kiwispinworld AS<br />
              Dronning Eufemias gate 16<br />
              0191 Oslo, Norway
            </li>
            <li>
              <span>🕒</span> <strong>Opening Hours:</strong><br />
              Monday–Friday: 09:00–17:00<br />
              Saturday–Sunday: Closed
            </li>
          </ul>
        </div>

        <div className="info-card important-info">
          <h2>💡 Important to know</h2>
          <p>Kiwispinworld only offers free social casino games for entertainment.</p>
          <p>There is no gambling, no purchases, and no real money winnings on this platform.</p>
          <p>For questions related to responsible gaming, we recommend <a href="http://www.hjelpelinjen.no" target="_blank" rel="noopener noreferrer">www.hjelpelinjen.no</a>.</p>
        </div>

        <div className="info-card privacy-info">
          <h2>🛡️ Privacy</h2>
          <p>Wondering how we handle your data?</p>
          <p>Read our <a href="/privacy-policy">Privacy Policy</a> and <a href="/terms-of-service">Terms of Service</a> for full information.</p>
        </div>
      </section>

      <section className="contact-form-section">
        <h2>✍️ Send us a message</h2>
        {submitMessage && (
          <div className={`message ${submitMessage.type}`}>
            {submitMessage.text}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your Name"
            />
          </div>
          
          <div className="form-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Your Email Address"
            />
          </div>
          
          <div className="form-group">
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              placeholder="Subject"
            />
          </div>
          
          <div className="form-group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Your Message"
              rows="5"
            ></textarea>
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </section>
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default ContactForm;
